import { cn } from '@/lib/utils';

/**
 * Selo PRO — a pílula âmbar é o PADRÃO ÚNICO do app para "isto é do plano pago".
 *
 * Antes convivia com uma coroa solta (`<Crown>`) em vários lugares: o ícone diz
 * "premium" para quem já conhece a convenção, mas não diz PRO — e o usuário
 * aprende o vocabulário pelos cards do dashboard, que sempre usaram a pílula.
 * Fonte única do estilo aqui; `MODULE_TAG_CLASS` (FiscalTags) reexporta esta
 * mesma classe para os selos de módulo continuarem idênticos.
 */
export const PRO_TAG_CLASS =
  'rounded-full bg-amber-500 px-1.5 py-0.5 text-[9px] font-bold leading-none text-white shadow';

export function ProTag({ className, title }: { className?: string; title?: string }) {
  return (
    <span className={cn(PRO_TAG_CLASS, className)} title={title ?? 'Disponível no plano PRO'}>
      PRO
    </span>
  );
}
